import React from 'react';
import { sectionDictionary } from './sectionDictionary';
import { GlobalSettingsInterface } from '@/types';

interface SectionZoneProps {
  section: any;
  layoutWidth?: string;
  globalSettings: GlobalSettingsInterface[];
}

function SectionZone({ section, layoutWidth, globalSettings }: SectionZoneProps) {
  const { _type } = section || {};
  let Component;

  if (sectionDictionary.hasOwnProperty(_type)) {
    Component = sectionDictionary[section._type as keyof typeof sectionDictionary];
  } else {
    return null;
  }

  return (
    <Component
      {...section}
      layoutWidth={layoutWidth}
      globalSettings={globalSettings}
    />
  );
}

export default SectionZone;
